<div class="waf-backdrop" *ngIf="open" role="dialog" aria-modal="true" arialabelledby="
waf-title">
  <div class="waf-modal" (keydown.escape)="cancel()">
    <div #container class="waf-container" aria-live="polite"></div>
    <div class="waf-actions">
      <button type="button" class="btn-cancel" (click)="cancel()"
              [disabled]="busy">Cancel</button>
    </div>
  </div>
</div>
